import type { Asset } from '@passkeys/assets';
import { useSelector } from 'react-redux';

import selectors from '@/ui/flux/selectors';
import useTestnetsEnabled from '@/ui/hooks/use-testnets-enabled';
import { isBaseAsset, isTestnetAsset } from '@/ui/utils/assets';

const useBaseAssets = (): Asset[] => {
  const allAssets: Asset[] = Object.values(useSelector(selectors.assets.all));
  const testnetsEnabled = useTestnetsEnabled();

  const baseAssets = allAssets.filter(
    (asset) =>
      isBaseAsset(asset) && (testnetsEnabled || !isTestnetAsset(asset)),
  );

  return baseAssets;
};
export default useBaseAssets;
